import React from 'react';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { ButtonGroup, InputText } from '@/components';
import { FormInputNameProducerLink } from '../../screens/SectorProduct/types';

export interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

export interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const ProducerProductLinkScreen: React.FC<Props> = ({
  formData,
  formErrors,
  onChangeFormInput,
}): JSX.Element => (
  <Form
    noValidate={true}
    onSubmit={(e): void => {
      e.preventDefault();
    }}
  >
    <Row>
      <Col md={8}>
        <h5 className="mb-5 border-bottom-title">Informações gerais e endereço</h5>

        <FormGroup className="mb-2">
          <ButtonGroup
            label="Permitir clonagem?"
            name="allowClone"
            value={formData[FormInputNameProducerLink.allowClone]}
            onChange={e => onChangeFormInput(FormInputNameProducerLink.allowClone)(e.target.value)}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.allowClone && formErrors.allowClone[0]}
          />
        </FormGroup>

        <FormGroup className="mb-2">
          <InputText
            name="sectionName"
            label="Nome do setor"
            placeholder="Digite o nome do setor"
            value={formData[FormInputNameProducerLink.sectionName]}
            onChange={e => onChangeFormInput(FormInputNameProducerLink.sectionName)(e.target.value)}
            error={formErrors.sectionName && formErrors.sectionName[0]}
          />
        </FormGroup>
      </Col>
    </Row>
  </Form>
);
